import { render, staticRenderFns } from "./widget-switch.vue?vue&type=template&id=64219c6c&scoped=true"
import script from "./widget-switch.vue?vue&type=script&lang=js"
export * from "./widget-switch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64219c6c",
  null
  
)

export default component.exports